import { useState, createContext, useContext } from "react";
import jwt_decode from "jwt-decode";
const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  const login = (userData) => {
    setUser(userData);
    sessionStorage.setItem("user", userData);
  };

  const logout = () => {
    setUser(null);
    sessionStorage.removeItem("user");
  };

  const decoder = (token) => {
    return {
      data: jwt_decode(token),
      token: token,
    };
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, decoder }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
